import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isInAppWebView() {
  const userAgent = navigator.userAgent || ''
  return /\bplayclub_ios_wrap\b/i.test(userAgent) || /\bplayclub_android_wrap\b/i.test(userAgent)
}
